/**
 * Landing Page Portabilidade - Interatividade
 * - Smooth scroll da navbar de âncoras
 * - Highlight do link ativo
 * - Carrossel de vantagens (translate no track, passo = 251 + 24 = 275px)
 * - FAQ accordion (nativo via <details>)
 * - Modal (gerenciado por alfa-ds.js via data-modal-open)
 */

(function () {
   'use strict';

   var NAV_LINK_SELECTOR = '.nav-port-lp__link';
   var CARD_STEP = 275; // largura do card (251px) + gap (24px)

   // Smooth scroll para os links âncora da navbar
   function initSmoothScroll() {
      var navLinks = document.querySelectorAll(NAV_LINK_SELECTOR + '[href^="#"]');

      navLinks.forEach(function (link) {
         link.addEventListener('click', function (e) {
            var targetId = this.getAttribute('href');
            var targetElement = document.querySelector(targetId);

            if (!targetElement) return;

            e.preventDefault();

            var headerOffset = 80;
            var offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset;

            window.scrollTo({
               top: offsetPosition,
               behavior: 'smooth',
            });
         });
      });
   }

   // Destacar o link da seção visível
   function initActiveNavLink() {
      var navLinks = document.querySelectorAll(NAV_LINK_SELECTOR);
      if (navLinks.length === 0) return;

      var sections = [];
      navLinks.forEach(function (link) {
         var section = document.querySelector(link.getAttribute('href'));
         if (section) sections.push({ link: link, section: section });
      });

      if (sections.length === 0) return;

      function highlightActiveSection() {
         var scrollPosition = window.pageYOffset + 150;
         var active = null;

         sections.forEach(function (item) {
            if (scrollPosition >= item.section.offsetTop) {
               active = item.link;
            }
         });

         navLinks.forEach(function (link) {
            link.classList.toggle('is-active', link === active);
         });
      }

      window.addEventListener('scroll', highlightActiveSection);
      highlightActiveSection();
   }

   // Carrossel de vantagens
   function initBenefitsCarousel() {
      var section = document.querySelector('.benefits-port-lp');
      if (!section) return;

      var carousel = section.querySelector('.benefits-port-lp__carousel');
      var track = section.querySelector('.benefits-port-lp__track');
      var cards = section.querySelectorAll('.benefits-port-lp__card');
      if (!track || cards.length === 0) return;

      // Controles Desktop
      var prevBtnDesktop = section.querySelector('.benefits-port-lp__nav-btn--prev');
      var nextBtnDesktop = section.querySelector('.benefits-port-lp__nav-btn--next');

      // Controles Mobile
      var controlsMobile = section.querySelector('.benefits-port-lp__controls');
      var prevBtnMobile = controlsMobile ? controlsMobile.querySelector('.benefits-port-lp__nav-mobile--prev') : null;
      var nextBtnMobile = controlsMobile ? controlsMobile.querySelector('.benefits-port-lp__nav-mobile--next') : null;
      var pagination = controlsMobile ? controlsMobile.querySelector('.benefits-port-lp__pagination') : null;

      var currentIndex = 0;

      // Detectar mobile
      function isMobile() {
         return window.innerWidth <= 767;
      }

      // Scroll nativo para mobile (baseado em initDocsCarousel)
      function scrollToCard(index) {
         if (!isMobile() || !carousel) return;

         var cardWidth = cards[0].offsetWidth;
         var gap = 24;
         var scrollPosition = index * (cardWidth + gap);

         carousel.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
         });
      }

      // Construir dots (mobile)
      function buildDots() {
         if (!pagination || !isMobile()) return;
         pagination.innerHTML = '';

         cards.forEach(function (_, index) {
            var dot = document.createElement('button');
            dot.className = 'benefits-port-lp__dot';
            dot.setAttribute('aria-label', 'Ir para card ' + (index + 1));
            if (index === 0) dot.classList.add('is-active');

            dot.addEventListener('click', function () {
               currentIndex = index;
               updateCarousel();
            });

            pagination.appendChild(dot);
         });
      }

      // Sincronizar dots (mobile)
      function syncDots() {
         if (!pagination || !isMobile()) return;

         var dots = pagination.querySelectorAll('.benefits-port-lp__dot');
         dots.forEach(function (dot, index) {
            if (index === currentIndex) {
               dot.classList.add('is-active');
            } else {
               dot.classList.remove('is-active');
            }
         });
      }

      // Atualizar estado dos botões
      function updateButtons() {
         var maxIndex = cards.length - getVisibleCards();

         if (isMobile()) {
            if (prevBtnMobile) prevBtnMobile.disabled = currentIndex === 0;
            if (nextBtnMobile) nextBtnMobile.disabled = currentIndex >= maxIndex;
         } else {
            if (prevBtnDesktop) {
               prevBtnDesktop.disabled = currentIndex === 0;
               prevBtnDesktop.setAttribute('aria-disabled', String(currentIndex === 0));
            }
            if (nextBtnDesktop) {
               nextBtnDesktop.disabled = currentIndex >= maxIndex;
               nextBtnDesktop.setAttribute('aria-disabled', String(currentIndex >= maxIndex));
            }
         }
      }

      // Calcular cards visíveis
      function getVisibleCards() {
         // Mobile usa scroll nativo, não precisa calcular
         if (isMobile()) {
            return 1; // Retorna 1 para não afetar lógica de botões mobile
         }

         // Desktop: usa largura do carousel (801px), não da section (~1180px)
         var carouselWidth = carousel.offsetWidth;
         var gap = 24;

         // Fórmula: considera que o último card visível não tem gap após ele
         // Exemplo com 801px: (801 + 24) / 275 = 825 / 275 = 3 cards
         return Math.floor((carouselWidth + gap) / CARD_STEP);
      }

      // Atualizar carousel
      function updateCarousel() {
         if (isMobile()) {
            // Mobile: usa scroll nativo
            scrollToCard(currentIndex);
         } else {
            // Desktop: usa transform (comportamento atual)
            var offset = -(currentIndex * CARD_STEP);
            track.style.transform = 'translateX(' + offset + 'px)';
         }

         // Atualizar botões
         var maxIndex = cards.length - getVisibleCards();

         if (isMobile()) {
            // Controles mobile
            if (prevBtnMobile) prevBtnMobile.disabled = currentIndex === 0;
            if (nextBtnMobile) nextBtnMobile.disabled = currentIndex >= maxIndex;
            syncDots();
         } else {
            // Controles desktop
            if (prevBtnDesktop) {
               prevBtnDesktop.disabled = currentIndex === 0;
               prevBtnDesktop.setAttribute('aria-disabled', String(currentIndex === 0));
            }
            if (nextBtnDesktop) {
               nextBtnDesktop.disabled = currentIndex >= maxIndex;
               nextBtnDesktop.setAttribute('aria-disabled', String(currentIndex >= maxIndex));
            }
         }
      }

      // Navegação
      function navigate(direction) {
         var maxIndex = cards.length - getVisibleCards();
         currentIndex += direction;
         currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
         updateCarousel();
      }

      // Event listeners desktop
      if (prevBtnDesktop) {
         prevBtnDesktop.addEventListener('click', function () {
            navigate(-1);
         });
      }
      if (nextBtnDesktop) {
         nextBtnDesktop.addEventListener('click', function () {
            navigate(1);
         });
      }

      // Event listeners mobile
      if (prevBtnMobile) {
         prevBtnMobile.addEventListener('click', function () {
            navigate(-1);
         });
      }
      if (nextBtnMobile) {
         nextBtnMobile.addEventListener('click', function () {
            navigate(1);
         });
      }

      // Detectar scroll manual no mobile (drag/swipe do usuário)
      if (carousel) {
         var scrollTimeout;
         carousel.addEventListener('scroll', function () {
            if (!isMobile()) return; // Só detecta no mobile

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
               var scrollLeft = carousel.scrollLeft;
               var cardWidth = cards[0].offsetWidth;
               var gap = 24;
               var newIndex = Math.round(scrollLeft / (cardWidth + gap));

               if (newIndex !== currentIndex) {
                  currentIndex = newIndex;
                  syncDots();
                  updateButtons();
               }
            }, 100); // Debounce 100ms
         });
      }

      // Resize handler
      var resizeTimeout;
      window.addEventListener('resize', function () {
         clearTimeout(resizeTimeout);
         resizeTimeout = setTimeout(function () {
            if (isMobile()) {
               buildDots();
               // Resetar scroll no mobile
               if (carousel) carousel.scrollTo({ left: 0 });
            } else {
               // Resetar transform no desktop
               track.style.transform = 'translateX(0)';
            }
            currentIndex = 0;
            updateCarousel();
         }, 250);
      });

      // Init
      if (isMobile()) {
         buildDots();
      }
      updateCarousel();
   }

   // Carrossel de documentação (mobile only)
   function initDocsCarousel() {
      // Só ativar no mobile
      if (window.innerWidth > 767) return;

      var section = document.querySelector('.docs-port-lp');
      if (!section) return;

      var container = section.querySelector('.docs-port-lp__cards');
      var cards = section.querySelectorAll('.docs-port-lp__card');
      var controls = section.querySelector('.docs-port-lp__controls');

      if (!container || cards.length === 0 || !controls) return;

      var prevBtn = controls.querySelector('.docs-port-lp__nav-mobile--prev');
      var nextBtn = controls.querySelector('.docs-port-lp__nav-mobile--next');
      var pagination = controls.querySelector('.docs-port-lp__pagination');

      var currentIndex = 0;

      // Construir dots
      function buildDots() {
         if (!pagination) return;
         pagination.innerHTML = '';

         cards.forEach(function (_, index) {
            var dot = document.createElement('button');
            dot.className = 'docs-port-lp__dot';
            dot.setAttribute('aria-label', 'Ir para documento ' + (index + 1));
            if (index === 0) dot.classList.add('is-active');

            dot.addEventListener('click', function () {
               currentIndex = index;
               scrollToCard(index);
            });

            pagination.appendChild(dot);
         });
      }

      // Scroll para card
      function scrollToCard(index) {
         var cardWidth = cards[0].offsetWidth;
         var gap = 16; // --space-16
         var scrollPosition = index * (cardWidth + gap);
         container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
         syncDots();
         updateButtons();
      }

      // Sincronizar dots
      function syncDots() {
         if (!pagination) return;
         var dots = pagination.querySelectorAll('.docs-port-lp__dot');
         dots.forEach(function (dot, index) {
            if (index === currentIndex) {
               dot.classList.add('is-active');
            } else {
               dot.classList.remove('is-active');
            }
         });
      }

      // Atualizar botões
      function updateButtons() {
         if (prevBtn) prevBtn.disabled = currentIndex === 0;
         if (nextBtn) nextBtn.disabled = currentIndex === cards.length - 1;
      }

      // Navegação
      function navigate(direction) {
         currentIndex += direction;
         currentIndex = Math.max(0, Math.min(currentIndex, cards.length - 1));
         scrollToCard(currentIndex);
      }

      // Event listeners
      if (prevBtn) {
         prevBtn.addEventListener('click', function () {
            navigate(-1);
         });
      }
      if (nextBtn) {
         nextBtn.addEventListener('click', function () {
            navigate(1);
         });
      }

      // Detectar scroll manual
      var scrollTimeout;
      container.addEventListener('scroll', function () {
         clearTimeout(scrollTimeout);
         scrollTimeout = setTimeout(function () {
            var scrollLeft = container.scrollLeft;
            var cardWidth = cards[0].offsetWidth;
            var gap = 16;
            var newIndex = Math.round(scrollLeft / (cardWidth + gap));

            if (newIndex !== currentIndex) {
               currentIndex = newIndex;
               syncDots();
               updateButtons();
            }
         }, 100);
      });

      // Resize handler
      var resizeTimeout;
      window.addEventListener('resize', function () {
         clearTimeout(resizeTimeout);
         resizeTimeout = setTimeout(function () {
            if (window.innerWidth > 767) {
               // Remover carousel no desktop
               container.scrollTo({ left: 0 });
               return;
            }
            currentIndex = 0;
            buildDots();
            updateButtons();
         }, 250);
      });

      // Init
      buildDots();
      updateButtons();
   }

   function init() {
      initSmoothScroll();
      initActiveNavLink();
      initBenefitsCarousel();
      initDocsCarousel();
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }
})();
